// 更新情報のデータ管理（idは自動生成されるため記載不要）
const rawUpdateData = [
  {
    date: '2025.11.23',
    title: '背景生成ツールをリリースしました',
    description: 'ちょっとしたときに使える背景を作れます',
    detailText: 'ちょっとしたときに使える背景を作れるツールをリリースしました。OBSにも簡単に導入できます。',
    isNew: true,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: '/bgcreate', isInternal: true }
    ]
  },
  {
    date: '2025.11.22',
    title: 'タイムゾーン対応時計に「ブルガリア」を追加',
    description: 'タイムゾーン対応グラデ時計に「ブルガリア」を追加しました。',
    detailText: 'タイムゾーン対応グラデ時計に「ブルガリア」を追加しました。必要なタイムゾーンがあれば追加できるのでご遠慮なくお問い合わせください。',
    isNew: true,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: '/clockcreate', isInternal: true }
    ]
  },
  {
    date: '2025.08.21',
    title: 'セットリスト管理ツール「セトリサン」アップデート',
    description: 'セトリサンに新しいデザインを追加しました。',
    detailText: 'セトリサンに新しいデザインを追加しました。通常配信と縦型配信のどちらにもマッチしたデザインがあります。',
    isNew: true,
    category: 'update',
    links: [
      { text: '詳しくはこちら', url: 'https://takatsukisyou.booth.pm/items/5826705', isInternal: false }
    ]
  },
  {
    date: '2025.07.07',
    title: '反射神経テストとクリック数テストを追加',
    description: '新しいテストコンテンツで反射神経と連打速度を測定できるようになりました',
    detailText: '反射神経テストとクリック数テストを追加しました',
    isNew: false,
    category: 'feature',
    links: [
      { text: '反射神経テスト', url: '/reaction-test', isInternal: true },
      { text: 'クリック数テスト', url: '/click-test', isInternal: true }
    ]
  },
  {
    date: '2024.12.15',
    title: 'DiscordオーバレイCSSがDiscord Reactiveに対応しました',
    description: 'カスタムCSSをDiscord Reactiveでも使えるようになりました',
    detailText: 'カスタムCSSをDiscord Reactiveでも使えるようになりました。',
    isNew: false,
    category: 'update',
    links: [
      { text: '詳しくはこちら', url: '/discordroom', isInternal: true }
    ]
  },
  {
    date: '2024.10.31',
    title: '半透明なコメント欄の新作をリリースしました',
    description: 'ゲーム画面にも合わせやすい半透明コメント欄、色も自由に変更可能',
    detailText: 'コメント用CSSの新作をリリースしました。半透明なのでゲーム画面にも合わせやすく、旧作と違い色も自由に変更できます。boothで販売中！',
    isNew: false,
    category: 'design',
    links: [
      { text: '詳しくはこちら', url: 'https://takatsukisyou.booth.pm/items/6224976', isInternal: false }
    ]
  },
  {
    date: '2024.10.15',
    title: 'タイムゾーンを変更可能な配信時計をリリースしました',
    description: '豊富なカラーバリエーションとタイムゾーン変更が可能な新作時計',
    detailText: '配信時計の新作リリースです。豊富なカラーバリエーションとタイムゾーンを変更可能なのが特徴です。boothで販売中！',
    isNew: false,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: '/clockcreate', isInternal: true }
    ]
  },
  {
    date: '2024.09.17',
    title: 'ルーレットツールをリリースしました',
    description: '軽量なルーレットアプリ、自由に項目を追加でき重みも設定可能',
    detailText: '軽量なルーレットアプリをリリースしました！自由に項目を追加でき、重みをつけることもできます。背景透過なので、ブラウザソースにも映しやすいです。',
    isNew: false,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: '/roulette', isInternal: true }
    ]
  },
  {
    date: '2024.07.19',
    title: 'カウンターツールをリリースしました',
    description: 'OBS用に簡単導入できるカウンターツール、フォントや背景をカスタマイズ可能',
    detailText: 'OBS用に簡単導入できる「カウンターツール」をリリースしました！フォントや背景をカスタマイズでき、OBSにカウントボタンを設置できます。配信で何かを数えたいときにピッタシです。',
    isNew: false,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: '/counter', isInternal: true }
    ]
  },
  {
    date: '2024.07.15',
    title: '【コメントCSS】吹き出しの色を変更できるようになりました',
    description: '有料版ふきだしコメントで背景色を変更可能に、白背景配信画面にも最適',
    detailText: '有料版の「ふきだしコメント」で背景色を変更できるようになりました！とくに背景が白の配信画面にも合わせやすくなったのがポイントです！\n🥝 すでにご購入の方は追加購入なしで使えます\n🥝 カスタムページの内容を追記するだけでOK\n🥝 詳細は商品同梱のReadmeに記載しています',
    isNew: false,
    category: 'update',
    links: [
      { text: '詳しくはこちら', url: '/ytcomment', isInternal: true }
    ]
  },
  {
    date: '2024.06.13',
    title: 'セットリスト管理ツール「セトリサン」リリース',
    description: 'OBS用セトリ管理ツール、曲リストから一曲ずつ表示可能、操作もOBSで完結',
    detailText: 'OBS用の「セトリ管理ツール」をリリースしました。用意した曲リストから、一曲ずつ表示できる便利なやつです。操作もOBSだけですべて完結するので超スマート！歌枠をよくする配信者さんにおすすめです。',
    isNew: false,
    category: 'feature',
    links: [
      { text: '詳しくはこちら', url: 'https://takatsukisyou.booth.pm/items/5826705', isInternal: false }
    ]
  }
];

// idを自動生成してupdateDataを作成（配列のインデックスをidとして使用）
export const updateData = rawUpdateData.map((update, index) => ({
  ...update,
  id: index
}));

// 最新の更新情報を取得
export const getLatestUpdate = () => {
  return updateData[0]; // 配列の最初の要素が最新
};

// 表示用の更新情報を取得（指定した数だけ）
export const getRecentUpdates = (count = 3) => {
  return updateData.slice(0, count);
};

// NEWバッジを表示すべき更新情報を取得
export const getNewUpdates = () => {
  return updateData.filter(update => update.isNew);
};

// 日付フォーマット用のヘルパー関数
export const formatUpdateDate = (dateString) => {
  return dateString.replace(/\./g, '/');
};

// noticeBar用の短縮された文字列を生成
export const getNoticeBarText = (update) => {
  return `${formatUpdateDate(update.date)} ${update.title}`;
};

// すべての更新情報を取得（newsページ用）
export const getAllUpdates = () => {
  return updateData;
};

// カテゴリー別の更新情報を取得
export const getUpdatesByCategory = (category) => {
  return updateData.filter(update => update.category === category);
};